import { db } from '../db/db';
import { getLocalDateString } from './dateUtils';

export const updateStreak = async () => {
  const todayStr = getLocalDateString();
  const settings = await db.settings.toCollection().first();
  
  if (settings) {
    let streak = settings.streakCount || 0;
    let bestStreak = settings.bestStreakCount || streak;
    const lastStudyDate = settings.lastStudyDate;

    if (lastStudyDate !== todayStr) {
      if (lastStudyDate) {
        const lastDay = new Date(lastStudyDate);
        const today = new Date(todayStr);
        // ignore time component
        lastDay.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);
        const diffTime = Math.abs(today.getTime() - lastDay.getTime());
        const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

        if (diffDays === 1) {
          streak += 1;
        } else if (diffDays > 1) {
          bestStreak = Math.max(bestStreak, streak);
          streak = 1; 
        }
      } else {
        streak = 1;
      }
      
      bestStreak = Math.max(bestStreak, streak);

      await db.settings.update(settings.id!, {
        streakCount: streak,
        bestStreakCount: bestStreak,
        lastStudyDate: todayStr
      });
    }
  } else {
    await db.settings.add({
      geminiApiKey: '',
      streakCount: 1,
      bestStreakCount: 1,
      lastStudyDate: todayStr
    });
  }
};

export const checkStreakOnLogin = async () => {
  const settings = await db.settings.toCollection().first();
  if (!settings) return;
  
  const todayStr = getLocalDateString();
  const lastStudyDate = settings.lastStudyDate;
  
  if (lastStudyDate && lastStudyDate !== todayStr) {
    const lastDay = new Date(lastStudyDate);
    const today = new Date(todayStr);
    lastDay.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffTime = Math.abs(today.getTime() - lastDay.getTime());
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 1 && settings.streakCount !== 0) {
      const bestStreak = Math.max(settings.bestStreakCount || 0, settings.streakCount || 0);
      await db.settings.update(settings.id!, {
        streakCount: 0,
        bestStreakCount: bestStreak
      });
    }
  }
};
